<template>
  <sidebar
  :addTitle="$t('MRMR.Period.AddNew')"
  :editTitle="$t('MRMR.Period.Edit')"
  :isSidebarActive="isSidebarActive"
  disableVerticalScroll="true"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form-wizard
          ref="wizard"
          color="rgba(var(--vs-primary), 1)"
          errorColor="rgba(var(--vs-danger), 1)"
          title=""
          subtitle=""
          :nextButtonText="$t('Next')"
          :backButtonText="$t('Back')"
          :finishButtonText="$t('Submit')"
          @on-complete="handleSubmit(submitData)"
        >
        <tab-content :title="$t('MRMR.Period.Step1')" class="mb-2" :before-change="validateStep1">
          <ValidationObserver ref="step1Observer">
            <div>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('MRMR.Period.Name')" rules="required" v-slot="{ errors }">
                    <validated-input
                    :label="$t('MRMR.Period.Name')"
                    v-model="model.name"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="6" class="mr-5">
                  <form-label>{{$t('MRMR.Period.PeriodDate')}}</form-label>
                  <ValidationProvider :name="$t('MRMR.Period.PeriodDate')" rules="required" v-slot="{ errors }">
                      <datepicker format="yyyy-MM-dd"
                                  :placeholder="$t('MRMR.Period.PeriodDate')" 
                                  v-model="model.periodDate"></datepicker>
                      <validation-message
                        >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                </vs-col>
                <vs-col vs-w="5">
                  <vs-checkbox v-model="model.isYearEnd" class="mb-2 mt-8">{{$t('MRMR.Period.IsYearEnd')}}</vs-checkbox>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-w="5">
                  <vs-checkbox v-model="model.isInternal" class="mt-5">{{$t('MRMR.Period.IsInternal')}}</vs-checkbox>
                </vs-col>
              </vs-row>
            </div>
          </ValidationObserver> 
        </tab-content>
        <tab-content :title="$t('MRMR.Period.Step2')" class="mb-2" >
          <vs-divider position="left-center">
            <vs-checkbox class="mb-2" v-model="isAllSelected">{{ $t('MRMR.Period.SelectAll') }}</vs-checkbox>
          </vs-divider>
          <div class="center checkbox-list">
            <vs-row class="mb-2">
              <vs-col vs-w="4" s-type="flex" vs-justify="center" vs-align="left">
                <form-label>{{$t('MRMR.Period.Project')}}</form-label>
              </vs-col>
              <vs-col vs-w="2" s-type="flex" vs-justify="center" vs-align="left">
                <form-label>{{$t('MRMR.Period.LastStartingPointDate')}}</form-label>
              </vs-col>
              <vs-col vs-w="4" s-type="flex" vs-justify="center" vs-align="left">
                <form-label>{{$t('MRMR.Period.UpdateType')}}</form-label>
              </vs-col>
              <vs-col vs-w="2" s-type="flex" vs-justify="center" vs-align="left">
                <form-label>{{$t('MRMR.Period.IsStartingPoint')}}</form-label>
              </vs-col>
            </vs-row>
            <vs-row v-for="(project, index) in projects" :key="index" class="mb-2" >
              <vs-col vs-w="4" s-type="flex" vs-justify="center" vs-align="left">
                <vs-checkbox :vs-value="project.isSelected" v-model="project.isSelected" >{{ project.name }}</vs-checkbox>
              </vs-col>
              <vs-col vs-w="2" s-type="flex" vs-justify="center" vs-align="left">
                <div v-show="project.lastStartingPointStatementDate" class="text-muted">
                  {{ project.lastStartingPointStatementDate | toDate }}
                </div>
              </vs-col>
              <vs-col vs-w="4" s-type="flex" vs-justify="center" vs-align="left">
                <ValidationProvider :name="$t('MRMR.Period.UpdateType')" rules="required" v-slot="{ errors }">
                  <v-select
                    v-show="project.isSelected"
                    label="name"
                    :options="updateTypes"
                    v-model="project.updateType"
                    :reduce="p => p.id"
                    clearable="false"
                    class="w-full flex-end pr-3 update-type-select"
                  />
                  <validation-message>{{ errors[0] }}</validation-message>
                </ValidationProvider>
              </vs-col>
              <vs-col vs-w="2" s-type="flex" vs-justify="center" vs-align="left">
                <vs-checkbox v-show="project.isSelected" :vs-value="project.isStartingPoint" v-model="project.isStartingPoint" />
              </vs-col>
            </vs-row>
          </div>
        </tab-content>
      </form-wizard>
    </ValidationObserver>
  </sidebar>
</template>

<script>

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "../../../../../shared/components";
import { FormWizard, TabContent } from "vue-form-wizard";
import Datepicker from 'vuejs-datepicker';
import ApplicationModuleEnum from "../../../ApplicationModuleEnum";
import UpdateTypeEnum from "../../../UpdateTypeEnum";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    Datepicker,
    FormWizard,
    TabContent,
    vSelect
  },
  data() {
    return {
      model : { 
        id: 0,
        name: "",
        periodDate: null,
        isYearEnd : false,
        isInternal : false,
        expectedProjects: []
      },
      projects: [],
      updateTypes: UpdateTypeEnum.definition
    };
  },
  computed: {
    isAllSelected: {
      get() {
        return this.projects.filter(x => x.isSelected).length === this.projects.length;
      },
      set(val) {
        if (val) {
          this.selectAll();
        } else {
          this.deselectAll();
        }
      }
    },
    enabledProjects() {
      const items = this.$store.state.mrmr.projects.filter(x => x.enabledModules & ApplicationModuleEnum.MRMR === ApplicationModuleEnum.MRMR);
      return items.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });
    }
  },
  methods: {
    selectAll() {
      this.projects.forEach((item) => {
        item.isSelected = true;
      });
    },
    deselectAll() {
      this.projects.forEach((item) => {
        item.isSelected = false;
      });
    },
    newData() {
      this.initValues();
      this.$refs.wizard.reset();
      this.$refs.step1Observer.reset();
    },
    editData() {
      this.model = JSON.parse(JSON.stringify(this.data));
      this.initProjects();
      this.$refs.wizard.reset();
      this.$refs.step1Observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.model.name = "";
      this.model.id = 0;
      this.model.periodDate = null;
      this.model.isYearEnd = false;
      this.model.isInternal = false;
      this.initProjects();
    },
    initProjects() {
      this.projects = this.enabledProjects.map(obj => {
        const expectedProject = this.model.expectedProjects.find(x => x.projectId === obj.id);
        return {
          projectId: obj.id,
          name : obj.name,
          isSelected: !!expectedProject,
          updateType: expectedProject ? expectedProject.updateType : 0,
          isStartingPoint: expectedProject ? expectedProject.isStartingPoint : false,
          lastStartingPointStatementDate: obj.lastStartingPointStatementDate
        }
      });
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    
    
    async submitData() {
      this.$refs.step1Observer.validate().then(result => {
        if (result) {
          
          this.model.expectedProjects = this.projects.filter(x => x.isSelected).map(x => {
            return {
              projectId: x.projectId,
              updateType: x.updateType,
              isStartingPoint: x.isStartingPoint
            }
          });
          const obj = this.model;
           
          if (Object.prototype.toString.call(this.model.periodDate) === "[object Date]") {
            obj.periodDate = this.$options.filters.toDate(this.model.periodDate);
          }
          else {
            obj.periodDate = this.model.periodDate;
          }

          this.$vs.loading();
          if (this.model.id !== null && this.model.id > 0) {
            this.$store.dispatch("mrmr/updatePeriod", obj).then((result) => {
              this.$emit("onPeriodUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("mrmr/addPeriod", obj).then((result) => {
              this.$emit("onPeriodInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">

.vs-sidebar {
  width: 760px !important;
}

.checkbox-list {
  height: calc(var(--vh, 1vh) * 100 - 400px);
  overflow-y: auto;
}

// hack to hide the clear button because the v-select clearable props doesn,t work
.update-type-select .vs__clear {
  display: none !important;
}

</style>
